export class Risk {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;

        this.$inputElement = $(this.$insuranceForm).find('select[name="risk"]');

        this._init();
    }

    _init() {
        $(this.$inputElement).selectize({
            onItemAdd: this._handler.bind(this),
        });
    }

    _handler(value) {
        this._state.risk = +value;
    }
}